import classNames         from 'classnames';
import * as React         from 'react';
import { useTranslation } from 'react-i18next';
import { Link }           from 'react-router-dom';

import { useCommon } from '../../../providers/common';

const CookieCheckbox = function(props) {
  const { t } = useTranslation();

  const {
          description,
          id,
          isChecked,
          isDisabled,
          setIsChecked,
          title,
        } = props;

  const common = useCommon();

  return (
    <div className={'cookie_checkbox'}>
      <input
        checked={isChecked}
        className={classNames({ disabled: isDisabled })}
        id={id}
        onChange={() => {
          setIsChecked((prevState) => ({
            ...prevState,
            [id]: !prevState[id],
          }));
        }}
        type={'checkbox'}
      />
      <label className={'cookie_label'} htmlFor={id}>
        {title}
      </label>
      <p>
        {description}
        {' '}
        <Link
          target={'_blank'}
          to={common.getUrlByTemplate('cookies-list')}
        >
          {t('cookie-settings.here')}
        </Link>
      </p>
    </div>
  );
};

export default CookieCheckbox;